import React, { ElementType, FC, forwardRef } from 'react';
import { Box, BoxProps, Container, ContainerProps } from '@mui/material';

export interface FooterProps extends BoxProps<ElementType> {
  /**
   * Props applied to container
   */
  containerProps?: ContainerProps<ElementType>;
}

/**
 * Component to render content at the bottom of each page
 */
export const Footer: FC<FooterProps> = forwardRef(
  (
    { sx, children, containerProps, primaryItems, secondaryItems, copyRight, location, socialButtons, ...rest },
    ref,
  ) => {
    return (
      <Box
        component="footer"
        sx={{
          py: 1,
          // complex footer has increased padding
          '&:has(.FlowSectionContact-root)': {
            py: { xs: 6, lg: 10 },
          },
          backgroundColor: 'onSurface.os800',
          color: 'common.white',
          // dividers inside
          '.MuiDivider-root': {
            borderColor: 'onSurface.os700',
            my: 4,
            // connect divider with FooterSectionMenu
            '& + .FooterSectionMenu-root': {
              marginTop: -4,
              // connect divider and accordion borders
              '& > .MuiAccordion-root:first-of-type': {
                borderTop: '0',
              },
            },
            // reduce divider space for the next compact accordion section
            '& + .FooterAccordion-variantCompact': {
              mt: -1.5,
              // also reduce the space of divider after the accordion
              '& + .MuiDivider-root': {
                mt: 4 - 1.5,
              },
            },
          },
          ...sx,
        }}
        ref={ref}
        data-testid="Footer"
        {...rest}
      >
        <Container maxWidth="xl" {...containerProps}>
          {children}
        </Container>
      </Box>
    );
  },
);
